module.exports = __webpack_public_path__ + "img/grand-palm-room.79e85438.jpg";